import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-15bee648")

_pushScopeId("data-v-15bee648")
const _hoisted_1 = { class: "welcome center" }
const _hoisted_2 = {
  key: 0,
  class: "welcome-description my3"
}
const _hoisted_3 = { class: "welcome-description my3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_QuickInstructions = _resolveComponent("QuickInstructions")!
  const _component_BaseNewGameLinks = _resolveComponent("BaseNewGameLinks")!
  const _component_BaseButtonWithSpinner = _resolveComponent("BaseButtonWithSpinner")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_QuickInstructions, { instructions: _ctx.instructions }, null, 8, ["instructions"]),
    _createVNode("div", _hoisted_1, [
      (_ctx.isCurrentUserAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('gamesCommon.inviteOthers')), 1))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.isCurrentUserAdmin ? _ctx.$t('gamesCommon.youWillStart') : _ctx.$t('gamesCommon.adminWillStart')), 1),
      _createVNode(_component_BaseNewGameLinks, {
        "is-current-user-admin": _ctx.isCurrentUserAdmin,
        "is-current-user-game-creator": _ctx.isCurrentUserGameCreator,
        "cancel-loading": _ctx.cancelGameLoading,
        "is-user-an-organisation-user": Boolean(_ctx.user?.email),
        onCopy: _ctx.copy,
        onCancel: _ctx.handleCancelGame
      }, null, 8, ["is-current-user-admin", "is-current-user-game-creator", "cancel-loading", "is-user-an-organisation-user", "onCopy", "onCancel"]),
      (_ctx.isCurrentUserAdmin && _ctx.showStartGameButton)
        ? (_openBlock(), _createBlock(_component_BaseButtonWithSpinner, {
            key: 1,
            onClick: _ctx.handleStartGame,
            loading: _ctx.startGameLoading
          }, {
            default: _withId(() => [
              _createVNode("b", null, _toDisplayString(_ctx.$t('common.startGame')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading"]))
        : _createCommentVNode("", true)
    ])
  ]))
})